/* eslint-disable prettier/prettier */
import { VariantType } from 'notistack';

type showFunc = (msg: string, variant: VariantType) => void;

let enqueueSnackbar: showFunc | null = null;

export function setEnqueueFunction(func: showFunc) {
  enqueueSnackbar = func;
}

export function showSnackbar(msg: string, variant: VariantType) {
  if (enqueueSnackbar && msg) {
    const getMsg = () => {
      try {
        return msg[0].toUpperCase() + msg.slice(1);
      } catch {
        return msg;
      }
    };
    enqueueSnackbar(getMsg(), variant);
  } else {
    console.error('Snackbar function not set');
  }
}
